import { useRouter } from 'next/router';
import { memo, useCallback } from 'react';

import { useAuth } from '../lib/auth';
import { Popup } from './modal';
import Navbar from './navbar';
import ProfileMenu from './ProfileMenu';

interface SettingsProps {
  onDismiss: () => void;
  showing: boolean;
}

const Settings: React.FC<SettingsProps> = ({ onDismiss, showing }) => {
  const router = useRouter();
  const { activeDeliveries, logout, user } = useAuth();

  const onRoute = useCallback((path: string) => router.push(path), [router]);

  const onLogout = useCallback(() => {
    if (user) {
      console.info(`Logging out user ${user.id}`);

      logout();
      router.push('/');
    }
  }, [logout, router, user]);

  return (
    <Popup onDismiss={onDismiss} showing={showing} size="full">
      <div className="relative flex flex-col h-full overflow-scroll">
        <Navbar showDismiss onAction={onDismiss} />

        <ProfileMenu
          className="mx-4 mb-6"
          user={user}
          hasActiveDeliveries={activeDeliveries > 0}
          onRoute={onRoute}
          onLogout={onLogout}
        />
      </div>
    </Popup>
  );
};

export default memo(Settings);
